/* globals ParametersManager */
/**
 * Shared checkout utilities module
 *
 * This module contains common functionality shared between the checkout
 * and shopping bag pages.
 */
SC.checkoutUtils = (function () {
  var api = {};

  /**
   * Show discount information on checkout/cart pages
   * Updates the summary section with promotion information
   *
   * @param {object} discountData - The discount data from the server
   * @param {object} options - Configuration options
   * @param {boolean} options.showCartItemDiscounts - Whether to show individual item discounts (shopping bag only)
   */
  api.showDiscounts = function (discountData, options) {
    options = options || {};

    // Reset summary
    $('.summary-row.summary-promotion-message').remove();

    // Append promotion summary before estimated total
    var promotionSummaryHtml = discountData.parsed_promo_summary;
    if (promotionSummaryHtml) {
      $('.summary-row.estimated-total').before(promotionSummaryHtml);
    }

    // Reset and show cart item discounts (shopping bag specific)
    if (options.showCartItemDiscounts) {
      $('.sc-item-list .list-item .item-quantity-price.item-discounted').removeClass('item-discounted');
      $('.sc-item-list .list-item .item-quantity-price.promo').remove();

      var cartItemDiscountedPrices = discountData.code.cart_item_prices;

      // Iterate shopping cart items and show their discount
      if (cartItemDiscountedPrices) {
        $('.sc-item-list .list-item').each(function () {
          var $listItem = $(this);
          var listItemId = $(this).data('id');
          var cartItemDiscountedPrice = cartItemDiscountedPrices[listItemId];

          if (cartItemDiscountedPrice) {
            var $cartItemPromoPrice = $('<span />', {
              'class': 'item-quantity-price promo',
              'aria-label': 'New Subtotal: ' + cartItemDiscountedPrice
            }).text(cartItemDiscountedPrice);

            $listItem.find('.item-quantity-price').addClass('item-discounted');
            $listItem.find('.item-quantity-price').after($cartItemPromoPrice);
          }
        });
      }
    }

    var promoCodeName = discountData.code.promo_code_name;

    // Clone and append the new applied promo code template
    if (promoCodeName) {
      var $appliedPromoCodeTemplateHTML = $('#applied-promo-code-template').clone().html();
      var $appliedPromoCodeTemplate = $($appliedPromoCodeTemplateHTML);

      $appliedPromoCodeTemplate.attr('data-promo-code', promoCodeName);
      $appliedPromoCodeTemplate.find('.message').text(promoCodeName + ' APPLIED');
      $('.sc-promo-code-form .applied-promo-message').append($appliedPromoCodeTemplate);

      $('.promo, .summary-promotion, .summary-promotion-message').show();
    }

    var checkoutSummary = discountData.checkout_summary;

    // Update checkout summary
    if (checkoutSummary) {
      $('.checkout-summary.sc-list-summary').replaceWith(checkoutSummary);
    }

    // Remove the promo code from the DOM we just removed
    var removePromoCode = discountData.code.removed_promo_code;
    if (removePromoCode) {
      $('.applied-promo-code-container[data-promo-code="' + removePromoCode + '"]').remove();
    }
  };

  /**
   * Modifies the active state properties of a form button.
   *
   * @param {HTMLElement} button - The target button node.
   * @param {boolean} activate - Whether to activate or deactivate the button.
   * @return {HTMLElement} The new button node
   */
  api.setButtonActiveState = function (button, activate) {
    var localButton = button.cloneNode(true);
    var enableButton = activate || !localButton.classList.contains('yellow-button');

    if (enableButton) {
      localButton.disabled = false;
      localButton.style.cursor = 'pointer';
      localButton.classList.replace('gray-button', 'yellow-button');
    } else {
      localButton.disabled = true;
      localButton.style.cursor = 'not-allowed';
      localButton.classList.replace('yellow-button', 'gray-button');
    }

    return localButton;
  };

  /**
   * Toggles a DOM button active state.
   *
   * @param {HTMLElement} buttonNode - The target button node
   * @param {HTMLElement} parentNode - Parent of the target node.
   * @return {HTMLElement} The new DOM node
   */
  api.toggleButtonState = function (buttonNode, parentNode) {
    var newButton = api.setButtonActiveState(buttonNode);
    parentNode.replaceChild(newButton, buttonNode);
    return newButton;
  };

  /**
   * Creates and returns an event handler function for sending checkout events
   * Adds common platform information to all events
   *
   * @return {function} Event dispatcher function
   */
  api.getSendCheckoutEventHandler = function () {
    var commonData = {
      'Platform': SC.utils.getCurrentPlatform()
    };

    return function (eventName, eventType, eventData, eventLabel) {
      var type = eventType || 'transaction';
      var data = {};

      Object.assign(data, eventData, commonData);

      SC.analytics.mp.sendEvent(eventName, type, data, eventLabel);
    };
  };

  /**
   * Collects browser information for payment processing
   *
   * @return {object} Browser information object
   */
  api.getBrowserInfo = function () {
    var colorDepth = window.screen.colorDepth;
    var javaEnabled = window.navigator.javaEnabled();
    var screenHeight = window.screen.height;
    var screenWidth = window.screen.width;
    var userAgent = window.navigator.userAgent;

    // IE <+ 10 supports navigator.browserLanguage instead of navigator.language
    var language = window.navigator.language;
    var d = new Date();
    var timeZoneOffset = d.getTimezoneOffset();

    return {
      colorDepth: colorDepth,
      javaEnabled: javaEnabled,
      language: language,
      screenHeight: screenHeight,
      screenWidth: screenWidth,
      userAgent: userAgent,
      timeZoneOffset: timeZoneOffset
    };
  };

  /**
   * Populates the browser info hidden field if present
   */
  api.populateBrowserInfo = function () {
    var browserInfoEl = document.getElementById('browser-info');
    if (browserInfoEl !== null) {
      browserInfoEl.value = JSON.stringify(api.getBrowserInfo());
    }
  };

  /**
   * Populates affiliate information from ParametersManager if available
   */
  api.populateAffiliateInfo = function () {
    var affiliateInfoEl = document.getElementById('affiliate-value');
    if (affiliateInfoEl !== null && affiliateInfoEl.value === '') {
      // Check if ParametersManager is available
      if (typeof ParametersManager !== 'undefined') {
        var raw = ParametersManager.retrieve();
        var affiliate = (raw && raw.duel_a && raw.duel_a.value) ? raw.duel_a.value : '';
        var time = (raw && raw.duel_a && raw.duel_a.time) ? raw.duel_a.time : '';
        affiliateInfoEl.value = affiliate;

        var latestImpressionEl = document.getElementById('latest-impression-at');
        if (latestImpressionEl !== null) {
          latestImpressionEl.value = time;
        }
      }
    }
  };

  /**
   * Initializes common checkout form fields (browser info, affiliate info)
   * Should be called on both checkout and shopping bag pages
   */
  api.initFormFields = function () {
    api.populateBrowserInfo();
    api.populateAffiliateInfo();
  };

  /**
   * Creates a handler for activating/deactivating promo code button based on input
   *
   * @param {string} containerSelector - Selector for the promo code container
   * @return {function} Event handler function
   */
  api.createPromoCodeButtonHandler = function (containerSelector) {
    return function (e) {
      var input = e.target;
      var promoCodeContainer = document.querySelector(containerSelector);
      var promoCodeButton = promoCodeContainer.querySelector('button');
      var isActive = promoCodeButton.classList.contains('yellow-button');
      var newButton;

      if (input.value && !isActive) {
        newButton = api.setButtonActiveState(promoCodeButton, true);
      } else if (!input.value && isActive) {
        newButton = api.setButtonActiveState(promoCodeButton, false);
      }

      if (newButton) {
        promoCodeContainer.replaceChild(newButton, promoCodeButton);
      }
    };
  };

  /**
   * Creates a handler for expanding/collapsing form sections
   *
   * @param {HTMLElement} titleEl - The expandable title element
   * @param {HTMLElement} contentEl - The expandable content element
   * @param {HTMLElement} focusEl - Element to focus after expansion (optional)
   * @return {function} Event handler function
   */
  api.createExpandHandler = function (titleEl, contentEl, focusEl) {
    return function (e) {
      if (e.type === 'keypress' && e.key !== 'Enter') {
        return;
      }

      var ariaExpanded = titleEl.getAttribute('aria-expanded');
      var transitionTime = 0;

      if (ariaExpanded === 'false') {
        setTimeout(function () {
          if (e.type !== 'iOSExpansion' && focusEl) {
            focusEl.focus();
          }
        }, 400);
      } else {
        transitionTime = 100;
      }

      setTimeout(function () {
        contentEl.classList.toggle('expanded');
        titleEl.classList.toggle('expanded');
        titleEl.setAttribute('aria-expanded', ariaExpanded === 'true' ? 'false' : 'true');
      }, transitionTime);
    };
  };

  /**
   * Creates a handler for activating/deactivating gift card button based on inputs
   *
   * @param {HTMLElement} gcForm - The gift card form element
   * @param {HTMLElement} gcNumber - The gift card number input
   * @param {HTMLElement} gcPin - The gift card pin input
   * @param {string} containerSelector - Selector for the input container within the form
   * @return {function} Event handler function
   */
  api.createGiftCardButtonHandler = function (gcForm, gcNumber, gcPin, containerSelector) {
    return function () {
      var gcButton = gcForm.querySelector('button');
      var gcInputsContainer = gcForm.querySelector(containerSelector);
      var isActive = gcButton.classList.contains('yellow-button');
      var inputsHaveValue = gcNumber && gcPin && ((gcNumber.value && gcPin.value) !== '');

      if (inputsHaveValue && !isActive) {
        gcInputsContainer.replaceChild(api.setButtonActiveState(gcButton, true), gcButton);
      } else if (!inputsHaveValue && isActive) {
        gcInputsContainer.replaceChild(api.setButtonActiveState(gcButton, false), gcButton);
      }
    };
  };

  return api;
})();
